import type { TelemetryBatchSeriesResultDto } from "@/lib/api/types";

export class HmiTelemetryCache {
  private readonly cache = new Map<string, TelemetryBatchSeriesResultDto>();

  setAll(entries: Record<string, TelemetryBatchSeriesResultDto>): void {
    for (const [key, value] of Object.entries(entries)) {
      this.cache.set(key, value);
    }
  }

  get(key: string): TelemetryBatchSeriesResultDto | undefined {
    return this.cache.get(key);
  }

  toJSON(): Record<string, TelemetryBatchSeriesResultDto> {
    return Object.fromEntries(this.cache.entries());
  }
}

